import ICompAddress from '@/models/CompAddress';
import ICompDatas from '@/models/comp/ICompDatas';

export default interface IAddCompDataRequest {
    compAddress: ICompAddress;
    compDatas: ICompDatas;
}

/**
 * Convenience method for creating a new request.
 * @param compAddress
 * @returns
 */
export function newAddCompDataRequest(compAddress: ICompAddress): IAddCompDataRequest {
    const request: IAddCompDataRequest = {
        compAddress: compAddress,
        compDatas: []
    };
    return request;
}
